module.exports = __webpack_public_path__ + "static/media/VK-Designs.ae25b47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screenshots/VK-Designs.png
// module id = 92
// module chunks = 0